// src/styles/colorThemes.js - 20 Beautiful Color Themes with Light & Dark Modes

export const colorThemes = {
  // Theme 1: Royal Purple
  royalPurple: {
    id: 'royalPurple',
    name: 'Royal Purple',
    dark: {
      primary: {
        main: '#667eea',
        light: '#8b9dff',
        dark: '#5568d3',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        glow: 'rgba(102, 126, 234, 0.4)',
      },
      secondary: {
        main: '#f093fb',
        light: '#f4a6ff',
        dark: '#e97df5',
        gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        glow: 'rgba(240, 147, 251, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#667eea', '#764ba2', '#f093fb', '#f5576c'],
    },
    light: {
      primary: {
        main: '#5568d3',
        light: '#667eea',
        dark: '#4c5bc0',
        gradient: 'linear-gradient(135deg, #5568d3 0%, #764ba2 100%)',
        glow: 'rgba(85, 104, 211, 0.25)',
      },
      secondary: {
        main: '#db2777',
        light: '#ec4899',
        dark: '#be185d',
        gradient: 'linear-gradient(135deg, #db2777 0%, #f5576c 100%)',
        glow: 'rgba(219, 39, 119, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#5568d3', '#764ba2', '#db2777', '#f5576c'],
    },
  },

  // Theme 2: Ocean Blue
  oceanBlue: {
    id: 'oceanBlue',
    name: 'Ocean Blue',
    dark: {
      primary: {
        main: '#3b82f6',
        light: '#60a5fa',
        dark: '#2563eb',
        gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        glow: 'rgba(59, 130, 246, 0.4)',
      },
      secondary: {
        main: '#06b6d4',
        light: '#22d3ee',
        dark: '#0891b2',
        gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        glow: 'rgba(6, 182, 212, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#3b82f6', '#1d4ed8', '#06b6d4', '#0891b2'],
    },
    light: {
      primary: {
        main: '#2563eb',
        light: '#3b82f6',
        dark: '#1d4ed8',
        gradient: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
        glow: 'rgba(37, 99, 235, 0.25)',
      },
      secondary: {
        main: '#0891b2',
        light: '#06b6d4',
        dark: '#0e7490',
        gradient: 'linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)',
        glow: 'rgba(8, 145, 178, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#2563eb', '#1d4ed8', '#0891b2', '#0e7490'],
    },
  },

  // Theme 3: Emerald Green
  emeraldGreen: {
    id: 'emeraldGreen',
    name: 'Emerald Green',
    dark: {
      primary: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      secondary: {
        main: '#14b8a6',
        light: '#5eead4',
        dark: '#0d9488',
        gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        glow: 'rgba(20, 184, 166, 0.4)',
      },
      success: {
        main: '#22c55e',
        light: '#4ade80',
        dark: '#16a34a',
        gradient: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        glow: 'rgba(34, 197, 94, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#10b981', '#059669', '#14b8a6', '#0d9488'],
    },
    light: {
      primary: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      secondary: {
        main: '#0d9488',
        light: '#14b8a6',
        dark: '#0f766e',
        gradient: 'linear-gradient(135deg, #0d9488 0%, #5eead4 100%)',
        glow: 'rgba(13, 148, 136, 0.25)',
      },
      success: {
        main: '#16a34a',
        light: '#22c55e',
        dark: '#15803d',
        gradient: 'linear-gradient(135deg, #16a34a 0%, #4ade80 100%)',
        glow: 'rgba(22, 163, 74, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#059669', '#047857', '#0d9488', '#0f766e'],
    },
  },

  // Theme 4: Sunset Orange
  sunsetOrange: {
    id: 'sunsetOrange',
    name: 'Sunset Orange',
    dark: {
      primary: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
        glow: 'rgba(249, 115, 22, 0.4)',
      },
      secondary: {
        main: '#fb923c',
        light: '#fdba74',
        dark: '#f97316',
        gradient: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
        glow: 'rgba(251, 146, 60, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#f97316', '#ea580c', '#fb923c', '#fdba74'],
    },
    light: {
      primary: {
        main: '#ea580c',
        light: '#f97316',
        dark: '#c2410c',
        gradient: 'linear-gradient(135deg, #ea580c 0%, #fb923c 100%)',
        glow: 'rgba(234, 88, 12, 0.25)',
      },
      secondary: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #fdba74 100%)',
        glow: 'rgba(249, 115, 22, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#ea580c', '#c2410c', '#f97316', '#fb923c'],
    },
  },

  // Theme 5: Rose Pink
  rosePink: {
    id: 'rosePink',
    name: 'Rose Pink',
    dark: {
      primary: {
        main: '#ec4899',
        light: '#f472b6',
        dark: '#db2777',
        gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
        glow: 'rgba(236, 72, 153, 0.4)',
      },
      secondary: {
        main: '#f472b6',
        light: '#f9a8d4',
        dark: '#ec4899',
        gradient: 'linear-gradient(135deg, #f472b6 0%, #ec4899 100%)',
        glow: 'rgba(244, 114, 182, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#ec4899', '#db2777', '#f472b6', '#f9a8d4'],
    },
    light: {
      primary: {
        main: '#db2777',
        light: '#ec4899',
        dark: '#be185d',
        gradient: 'linear-gradient(135deg, #db2777 0%, #f472b6 100%)',
        glow: 'rgba(219, 39, 119, 0.25)',
      },
      secondary: {
        main: '#ec4899',
        light: '#f472b6',
        dark: '#db2777',
        gradient: 'linear-gradient(135deg, #ec4899 0%, #f9a8d4 100%)',
        glow: 'rgba(236, 72, 153, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#db2777', '#be185d', '#ec4899', '#f472b6'],
    },
  },

  // Theme 6: Cyan Teal
  cyanTeal: {
    id: 'cyanTeal',
    name: 'Cyan Teal',
    dark: {
      primary: {
        main: '#14b8a6',
        light: '#5eead4',
        dark: '#0d9488',
        gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        glow: 'rgba(20, 184, 166, 0.4)',
      },
      secondary: {
        main: '#06b6d4',
        light: '#22d3ee',
        dark: '#0891b2',
        gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        glow: 'rgba(6, 182, 212, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#14b8a6', '#0d9488', '#06b6d4', '#0891b2'],
    },
    light: {
      primary: {
        main: '#0d9488',
        light: '#14b8a6',
        dark: '#0f766e',
        gradient: 'linear-gradient(135deg, #0d9488 0%, #5eead4 100%)',
        glow: 'rgba(13, 148, 136, 0.25)',
      },
      secondary: {
        main: '#0891b2',
        light: '#06b6d4',
        dark: '#0e7490',
        gradient: 'linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)',
        glow: 'rgba(8, 145, 178, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#0d9488', '#0f766e', '#0891b2', '#0e7490'],
    },
  },

  // Theme 7: Indigo Night
  indigoNight: {
    id: 'indigoNight',
    name: 'Indigo Night',
    dark: {
      primary: {
        main: '#6366f1',
        light: '#818cf8',
        dark: '#4f46e5',
        gradient: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
        glow: 'rgba(99, 102, 241, 0.4)',
      },
      secondary: {
        main: '#8b5cf6',
        light: '#a78bfa',
        dark: '#7c3aed',
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
        glow: 'rgba(139, 92, 246, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#6366f1', '#4f46e5', '#8b5cf6', '#7c3aed'],
    },
    light: {
      primary: {
        main: '#4f46e5',
        light: '#6366f1',
        dark: '#4338ca',
        gradient: 'linear-gradient(135deg, #4f46e5 0%, #818cf8 100%)',
        glow: 'rgba(79, 70, 229, 0.25)',
      },
      secondary: {
        main: '#7c3aed',
        light: '#8b5cf6',
        dark: '#6d28d9',
        gradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
        glow: 'rgba(124, 58, 237, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#4f46e5', '#4338ca', '#7c3aed', '#6d28d9'],
    },
  },

  // Theme 8: Amber Gold
  amberGold: {
    id: 'amberGold',
    name: 'Amber Gold',
    dark: {
      primary: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      secondary: {
        main: '#eab308',
        light: '#facc15',
        dark: '#ca8a04',
        gradient: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)',
        glow: 'rgba(234, 179, 8, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
        glow: 'rgba(249, 115, 22, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#f59e0b', '#d97706', '#eab308', '#ca8a04'],
    },
    light: {
      primary: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      secondary: {
        main: '#ca8a04',
        light: '#eab308',
        dark: '#a16207',
        gradient: 'linear-gradient(135deg, #ca8a04 0%, #facc15 100%)',
        glow: 'rgba(202, 138, 4, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#ea580c',
        light: '#f97316',
        dark: '#c2410c',
        gradient: 'linear-gradient(135deg, #ea580c 0%, #fb923c 100%)',
        glow: 'rgba(234, 88, 12, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#d97706', '#b45309', '#ca8a04', '#a16207'],
    },
  },

  // Theme 9: Violet Dream
  violetDream: {
    id: 'violetDream',
    name: 'Violet Dream',
    dark: {
      primary: {
        main: '#8b5cf6',
        light: '#a78bfa',
        dark: '#7c3aed',
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
        glow: 'rgba(139, 92, 246, 0.4)',
      },
      secondary: {
        main: '#a855f7',
        light: '#c084fc',
        dark: '#9333ea',
        gradient: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
        glow: 'rgba(168, 85, 247, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#8b5cf6', '#7c3aed', '#a855f7', '#9333ea'],
    },
    light: {
      primary: {
        main: '#7c3aed',
        light: '#8b5cf6',
        dark: '#6d28d9',
        gradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
        glow: 'rgba(124, 58, 237, 0.25)',
      },
      secondary: {
        main: '#9333ea',
        light: '#a855f7',
        dark: '#7e22ce',
        gradient: 'linear-gradient(135deg, #9333ea 0%, #c084fc 100%)',
        glow: 'rgba(147, 51, 234, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#7c3aed', '#6d28d9', '#9333ea', '#7e22ce'],
    },
  },

  // Theme 10: Sky Blue
  skyBlue: {
    id: 'skyBlue',
    name: 'Sky Blue',
    dark: {
      primary: {
        main: '#0ea5e9',
        light: '#38bdf8',
        dark: '#0284c7',
        gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
        glow: 'rgba(14, 165, 233, 0.4)',
      },
      secondary: {
        main: '#06b6d4',
        light: '#22d3ee',
        dark: '#0891b2',
        gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        glow: 'rgba(6, 182, 212, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#0ea5e9', '#0284c7', '#06b6d4', '#0891b2'],
    },
    light: {
      primary: {
        main: '#0284c7',
        light: '#0ea5e9',
        dark: '#0369a1',
        gradient: 'linear-gradient(135deg, #0284c7 0%, #38bdf8 100%)',
        glow: 'rgba(2, 132, 199, 0.25)',
      },
      secondary: {
        main: '#0891b2',
        light: '#06b6d4',
        dark: '#0e7490',
        gradient: 'linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)',
        glow: 'rgba(8, 145, 178, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#0284c7', '#0369a1', '#0891b2', '#0e7490'],
    },
  },

  // Theme 11: Mint Fresh
  mintFresh: {
    id: 'mintFresh',
    name: 'Mint Fresh',
    dark: {
      primary: {
        main: '#06b6d4',
        light: '#22d3ee',
        dark: '#0891b2',
        gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        glow: 'rgba(6, 182, 212, 0.4)',
      },
      secondary: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      success: {
        main: '#22c55e',
        light: '#4ade80',
        dark: '#16a34a',
        gradient: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        glow: 'rgba(34, 197, 94, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#06b6d4', '#0891b2', '#10b981', '#059669'],
    },
    light: {
      primary: {
        main: '#0891b2',
        light: '#06b6d4',
        dark: '#0e7490',
        gradient: 'linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)',
        glow: 'rgba(8, 145, 178, 0.25)',
      },
      secondary: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      success: {
        main: '#16a34a',
        light: '#22c55e',
        dark: '#15803d',
        gradient: 'linear-gradient(135deg, #16a34a 0%, #4ade80 100%)',
        glow: 'rgba(22, 163, 74, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#0891b2', '#0e7490', '#059669', '#047857'],
    },
  },

  // Theme 12: Coral Reef
  coralReef: {
    id: 'coralReef',
    name: 'Coral Reef',
    dark: {
      primary: {
        main: '#f87171',
        light: '#fca5a5',
        dark: '#ef4444',
        gradient: 'linear-gradient(135deg, #f87171 0%, #ef4444 100%)',
        glow: 'rgba(248, 113, 113, 0.4)',
      },
      secondary: {
        main: '#fb923c',
        light: '#fdba74',
        dark: '#f97316',
        gradient: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
        glow: 'rgba(251, 146, 60, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        glow: 'rgba(220, 38, 38, 0.4)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #991b1b 100%)',
        glow: 'rgba(185, 28, 28, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#f87171', '#ef4444', '#fb923c', '#f97316'],
    },
    light: {
      primary: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #fca5a5 100%)',
        glow: 'rgba(239, 68, 68, 0.25)',
      },
      secondary: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #fdba74 100%)',
        glow: 'rgba(249, 115, 22, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #f87171 100%)',
        glow: 'rgba(185, 28, 28, 0.25)',
      },
      emergency: {
        main: '#991b1b',
        light: '#b91c1c',
        dark: '#7f1d1d',
        gradient: 'linear-gradient(135deg, #991b1b 0%, #dc2626 100%)',
        glow: 'rgba(153, 27, 27, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#ef4444', '#dc2626', '#f97316', '#ea580c'],
    },
  },

  // Theme 13: Lavender Mist
  lavenderMist: {
    id: 'lavenderMist',
    name: 'Lavender Mist',
    dark: {
      primary: {
        main: '#a78bfa',
        light: '#c4b5fd',
        dark: '#8b5cf6',
        gradient: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
        glow: 'rgba(167, 139, 250, 0.4)',
      },
      secondary: {
        main: '#c084fc',
        light: '#ddd6fe',
        dark: '#a855f7',
        gradient: 'linear-gradient(135deg, #c084fc 0%, #a855f7 100%)',
        glow: 'rgba(192, 132, 252, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#a78bfa', '#8b5cf6', '#c084fc', '#a855f7'],
    },
    light: {
      primary: {
        main: '#8b5cf6',
        light: '#a78bfa',
        dark: '#7c3aed',
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #c4b5fd 100%)',
        glow: 'rgba(139, 92, 246, 0.25)',
      },
      secondary: {
        main: '#a855f7',
        light: '#c084fc',
        dark: '#9333ea',
        gradient: 'linear-gradient(135deg, #a855f7 0%, #ddd6fe 100%)',
        glow: 'rgba(168, 85, 247, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#8b5cf6', '#7c3aed', '#a855f7', '#9333ea'],
    },
  },

  // Theme 14: Forest Green
  forestGreen: {
    id: 'forestGreen',
    name: 'Forest Green',
    dark: {
      primary: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
        glow: 'rgba(5, 150, 105, 0.4)',
      },
      secondary: {
        main: '#16a34a',
        light: '#22c55e',
        dark: '#15803d',
        gradient: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
        glow: 'rgba(22, 163, 74, 0.4)',
      },
      success: {
        main: '#22c55e',
        light: '#4ade80',
        dark: '#16a34a',
        gradient: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        glow: 'rgba(34, 197, 94, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#059669', '#047857', '#16a34a', '#15803d'],
    },
    light: {
      primary: {
        main: '#047857',
        light: '#059669',
        dark: '#065f46',
        gradient: 'linear-gradient(135deg, #047857 0%, #10b981 100%)',
        glow: 'rgba(4, 120, 87, 0.25)',
      },
      secondary: {
        main: '#15803d',
        light: '#16a34a',
        dark: '#166534',
        gradient: 'linear-gradient(135deg, #15803d 0%, #22c55e 100%)',
        glow: 'rgba(21, 128, 61, 0.25)',
      },
      success: {
        main: '#16a34a',
        light: '#22c55e',
        dark: '#15803d',
        gradient: 'linear-gradient(135deg, #16a34a 0%, #4ade80 100%)',
        glow: 'rgba(22, 163, 74, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#047857', '#065f46', '#15803d', '#166534'],
    },
  },

  // Theme 15: Cherry Blossom
  cherryBlossom: {
    id: 'cherryBlossom',
    name: 'Cherry Blossom',
    dark: {
      primary: {
        main: '#f472b6',
        light: '#f9a8d4',
        dark: '#ec4899',
        gradient: 'linear-gradient(135deg, #f472b6 0%, #ec4899 100%)',
        glow: 'rgba(244, 114, 182, 0.4)',
      },
      secondary: {
        main: '#fb7185',
        light: '#fda4af',
        dark: '#f43f5e',
        gradient: 'linear-gradient(135deg, #fb7185 0%, #f43f5e 100%)',
        glow: 'rgba(251, 113, 133, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#f472b6', '#ec4899', '#fb7185', '#f43f5e'],
    },
    light: {
      primary: {
        main: '#ec4899',
        light: '#f472b6',
        dark: '#db2777',
        gradient: 'linear-gradient(135deg, #ec4899 0%, #f9a8d4 100%)',
        glow: 'rgba(236, 72, 153, 0.25)',
      },
      secondary: {
        main: '#f43f5e',
        light: '#fb7185',
        dark: '#e11d48',
        gradient: 'linear-gradient(135deg, #f43f5e 0%, #fda4af 100%)',
        glow: 'rgba(244, 63, 94, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#ec4899', '#db2777', '#f43f5e', '#e11d48'],
    },
  },

  // Theme 16: Sapphire Blue
  sapphireBlue: {
    id: 'sapphireBlue',
    name: 'Sapphire Blue',
    dark: {
      primary: {
        main: '#2563eb',
        light: '#3b82f6',
        dark: '#1d4ed8',
        gradient: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
        glow: 'rgba(37, 99, 235, 0.4)',
      },
      secondary: {
        main: '#1e40af',
        light: '#2563eb',
        dark: '#1e3a8a',
        gradient: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)',
        glow: 'rgba(30, 64, 175, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#2563eb', '#1d4ed8', '#1e40af', '#1e3a8a'],
    },
    light: {
      primary: {
        main: '#1d4ed8',
        light: '#2563eb',
        dark: '#1e40af',
        gradient: 'linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%)',
        glow: 'rgba(29, 78, 216, 0.25)',
      },
      secondary: {
        main: '#1e3a8a',
        light: '#1e40af',
        dark: '#1e3a8a',
        gradient: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
        glow: 'rgba(30, 58, 138, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#1d4ed8', '#1e40af', '#1e3a8a', '#1e3a8a'],
    },
  },

  // Theme 17: Peach Sunset
  peachSunset: {
    id: 'peachSunset',
    name: 'Peach Sunset',
    dark: {
      primary: {
        main: '#fb923c',
        light: '#fdba74',
        dark: '#f97316',
        gradient: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
        glow: 'rgba(251, 146, 60, 0.4)',
      },
      secondary: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
        glow: 'rgba(249, 115, 22, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#fb923c', '#f97316', '#f97316', '#ea580c'],
    },
    light: {
      primary: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #fdba74 100%)',
        glow: 'rgba(249, 115, 22, 0.25)',
      },
      secondary: {
        main: '#ea580c',
        light: '#f97316',
        dark: '#c2410c',
        gradient: 'linear-gradient(135deg, #ea580c 0%, #fb923c 100%)',
        glow: 'rgba(234, 88, 12, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#f97316', '#ea580c', '#ea580c', '#c2410c'],
    },
  },

  // Theme 18: Electric Purple
  electricPurple: {
    id: 'electricPurple',
    name: 'Electric Purple',
    dark: {
      primary: {
        main: '#9333ea',
        light: '#a855f7',
        dark: '#7e22ce',
        gradient: 'linear-gradient(135deg, #9333ea 0%, #7e22ce 100%)',
        glow: 'rgba(147, 51, 234, 0.4)',
      },
      secondary: {
        main: '#a855f7',
        light: '#c084fc',
        dark: '#9333ea',
        gradient: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
        glow: 'rgba(168, 85, 247, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#9333ea', '#7e22ce', '#a855f7', '#c084fc'],
    },
    light: {
      primary: {
        main: '#7e22ce',
        light: '#9333ea',
        dark: '#6b21a8',
        gradient: 'linear-gradient(135deg, #7e22ce 0%, #a855f7 100%)',
        glow: 'rgba(126, 34, 206, 0.25)',
      },
      secondary: {
        main: '#9333ea',
        light: '#a855f7',
        dark: '#7e22ce',
        gradient: 'linear-gradient(135deg, #9333ea 0%, #c084fc 100%)',
        glow: 'rgba(147, 51, 234, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#7e22ce', '#6b21a8', '#9333ea', '#7e22ce'],
    },
  },

  // Theme 19: Turquoise Wave
  turquoiseWave: {
    id: 'turquoiseWave',
    name: 'Turquoise Wave',
    dark: {
      primary: {
        main: '#06b6d4',
        light: '#22d3ee',
        dark: '#0891b2',
        gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        glow: 'rgba(6, 182, 212, 0.4)',
      },
      secondary: {
        main: '#14b8a6',
        light: '#5eead4',
        dark: '#0d9488',
        gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        glow: 'rgba(20, 184, 166, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#06b6d4', '#0891b2', '#14b8a6', '#0d9488'],
    },
    light: {
      primary: {
        main: '#0891b2',
        light: '#06b6d4',
        dark: '#0e7490',
        gradient: 'linear-gradient(135deg, #0891b2 0%, #22d3ee 100%)',
        glow: 'rgba(8, 145, 178, 0.25)',
      },
      secondary: {
        main: '#0d9488',
        light: '#14b8a6',
        dark: '#0f766e',
        gradient: 'linear-gradient(135deg, #0d9488 0%, #5eead4 100%)',
        glow: 'rgba(13, 148, 136, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#0891b2', '#0e7490', '#0d9488', '#0f766e'],
    },
  },

  // Theme 20: Magenta Fusion
  magentaFusion: {
    id: 'magentaFusion',
    name: 'Magenta Fusion',
    dark: {
      primary: {
        main: '#d946ef',
        light: '#e879f9',
        dark: '#c026d3',
        gradient: 'linear-gradient(135deg, #d946ef 0%, #c026d3 100%)',
        glow: 'rgba(217, 70, 239, 0.4)',
      },
      secondary: {
        main: '#ec4899',
        light: '#f472b6',
        dark: '#db2777',
        gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
        glow: 'rgba(236, 72, 153, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#d946ef', '#c026d3', '#ec4899', '#db2777'],
    },
    light: {
      primary: {
        main: '#c026d3',
        light: '#d946ef',
        dark: '#a21caf',
        gradient: 'linear-gradient(135deg, #c026d3 0%, #e879f9 100%)',
        glow: 'rgba(192, 38, 211, 0.25)',
      },
      secondary: {
        main: '#db2777',
        light: '#ec4899',
        dark: '#be185d',
        gradient: 'linear-gradient(135deg, #db2777 0%, #f472b6 100%)',
        glow: 'rgba(219, 39, 119, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#c026d3', '#a21caf', '#db2777', '#be185d'],
    },
  },

  // Theme 21: Golden Yellow (Dashboard Default)
  goldenYellow: {
    id: 'goldenYellow',
    name: 'Golden Yellow',
    dark: {
      primary: {
        main: '#f4df26',
        light: '#f6e84d',
        dark: '#d4bf1e',
        gradient: 'linear-gradient(135deg, #f4df26 0%, #e6cc1f 100%)',
        glow: 'rgba(244, 223, 38, 0.4)',
      },
      secondary: {
        main: '#fbbf24',
        light: '#fcd34d',
        dark: '#f59e0b',
        gradient: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
        glow: 'rgba(251, 191, 36, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#f4df26', '#e6cc1f', '#fbbf24', '#f59e0b'],
    },
    light: {
      primary: {
        main: '#d4bf1e',
        light: '#f4df26',
        dark: '#b8a41a',
        gradient: 'linear-gradient(135deg, #d4bf1e 0%, #f4df26 100%)',
        glow: 'rgba(212, 191, 30, 0.25)',
      },
      secondary: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#d4bf1e', '#f4df26', '#f59e0b', '#d97706'],
    },
  },

  // Theme 22: Bright Gold
  brightGold: {
    id: 'brightGold',
    name: 'Bright Gold',
    dark: {
      primary: {
        main: '#eab308',
        light: '#facc15',
        dark: '#ca8a04',
        gradient: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)',
        glow: 'rgba(234, 179, 8, 0.4)',
      },
      secondary: {
        main: '#f4df26',
        light: '#f6e84d',
        dark: '#d4bf1e',
        gradient: 'linear-gradient(135deg, #f4df26 0%, #e6cc1f 100%)',
        glow: 'rgba(244, 223, 38, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#eab308', '#ca8a04', '#f4df26', '#e6cc1f'],
    },
    light: {
      primary: {
        main: '#ca8a04',
        light: '#eab308',
        dark: '#a16207',
        gradient: 'linear-gradient(135deg, #ca8a04 0%, #eab308 100%)',
        glow: 'rgba(202, 138, 4, 0.25)',
      },
      secondary: {
        main: '#d4bf1e',
        light: '#f4df26',
        dark: '#b8a41a',
        gradient: 'linear-gradient(135deg, #d4bf1e 0%, #f4df26 100%)',
        glow: 'rgba(212, 191, 30, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#ca8a04', '#eab308', '#d4bf1e', '#b8a41a'],
    },
  },

  // Theme 23: Golden Sun
  goldenSun: {
    id: 'goldenSun',
    name: 'Golden Sun',
    dark: {
      primary: {
        main: '#fbbf24',
        light: '#fcd34d',
        dark: '#f59e0b',
        gradient: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
        glow: 'rgba(251, 191, 36, 0.4)',
      },
      secondary: {
        main: '#f4df26',
        light: '#f6e84d',
        dark: '#e6cc1f',
        gradient: 'linear-gradient(135deg, #f4df26 0%, #e6cc1f 100%)',
        glow: 'rgba(244, 223, 38, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f97316',
        light: '#fb923c',
        dark: '#ea580c',
        gradient: 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)',
        glow: 'rgba(249, 115, 22, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#fbbf24', '#f59e0b', '#f4df26', '#f97316'],
    },
    light: {
      primary: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.25)',
      },
      secondary: {
        main: '#e6cc1f',
        light: '#f4df26',
        dark: '#d4bf1e',
        gradient: 'linear-gradient(135deg, #e6cc1f 0%, #f4df26 100%)',
        glow: 'rgba(230, 204, 31, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#ea580c',
        light: '#f97316',
        dark: '#c2410c',
        gradient: 'linear-gradient(135deg, #ea580c 0%, #fb923c 100%)',
        glow: 'rgba(234, 88, 12, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#f59e0b', '#fbbf24', '#e6cc1f', '#ea580c'],
    },
  },

  // Theme 24: Yellow Amber
  yellowAmber: {
    id: 'yellowAmber',
    name: 'Yellow Amber',
    dark: {
      primary: {
        main: '#facc15',
        light: '#fde047',
        dark: '#eab308',
        gradient: 'linear-gradient(135deg, #facc15 0%, #eab308 100%)',
        glow: 'rgba(250, 204, 21, 0.4)',
      },
      secondary: {
        main: '#f4df26',
        light: '#f6e84d',
        dark: '#e6cc1f',
        gradient: 'linear-gradient(135deg, #f4df26 0%, #e6cc1f 100%)',
        glow: 'rgba(244, 223, 38, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#facc15', '#eab308', '#f4df26', '#f59e0b'],
    },
    light: {
      primary: {
        main: '#eab308',
        light: '#facc15',
        dark: '#ca8a04',
        gradient: 'linear-gradient(135deg, #eab308 0%, #facc15 100%)',
        glow: 'rgba(234, 179, 8, 0.25)',
      },
      secondary: {
        main: '#e6cc1f',
        light: '#f4df26',
        dark: '#d4bf1e',
        gradient: 'linear-gradient(135deg, #e6cc1f 0%, #f4df26 100%)',
        glow: 'rgba(230, 204, 31, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#eab308', '#facc15', '#e6cc1f', '#d97706'],
    },
  },

  // Theme 25: Gold Rush
  goldRush: {
    id: 'goldRush',
    name: 'Gold Rush',
    dark: {
      primary: {
        main: '#e6cc1f',
        light: '#f4df26',
        dark: '#d4bf1e',
        gradient: 'linear-gradient(135deg, #e6cc1f 0%, #d4bf1e 100%)',
        glow: 'rgba(230, 204, 31, 0.4)',
      },
      secondary: {
        main: '#fbbf24',
        light: '#fcd34d',
        dark: '#f59e0b',
        gradient: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
        glow: 'rgba(251, 191, 36, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#e6cc1f', '#d4bf1e', '#fbbf24', '#f59e0b'],
    },
    light: {
      primary: {
        main: '#d4bf1e',
        light: '#e6cc1f',
        dark: '#b8a41a',
        gradient: 'linear-gradient(135deg, #d4bf1e 0%, #e6cc1f 100%)',
        glow: 'rgba(212, 191, 30, 0.25)',
      },
      secondary: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#d4bf1e', '#e6cc1f', '#f59e0b', '#d97706'],
    },
  },

  // Theme 26: Lemon Gold
  lemonGold: {
    id: 'lemonGold',
    name: 'Lemon Gold',
    dark: {
      primary: {
        main: '#fde047',
        light: '#fef08a',
        dark: '#facc15',
        gradient: 'linear-gradient(135deg, #fde047 0%, #facc15 100%)',
        glow: 'rgba(253, 224, 71, 0.4)',
      },
      secondary: {
        main: '#f4df26',
        light: '#f6e84d',
        dark: '#e6cc1f',
        gradient: 'linear-gradient(135deg, #f4df26 0%, #e6cc1f 100%)',
        glow: 'rgba(244, 223, 38, 0.4)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        glow: 'rgba(16, 185, 129, 0.4)',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
        glow: 'rgba(245, 158, 11, 0.4)',
      },
      danger: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        gradient: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
        glow: 'rgba(239, 68, 68, 0.4)',
      },
      emergency: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
        glow: 'rgba(220, 38, 38, 0.6)',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.95)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        muted: 'rgba(255, 255, 255, 0.5)',
      },
      preview: ['#fde047', '#facc15', '#f4df26', '#eab308'],
    },
    light: {
      primary: {
        main: '#facc15',
        light: '#fde047',
        dark: '#eab308',
        gradient: 'linear-gradient(135deg, #facc15 0%, #fde047 100%)',
        glow: 'rgba(250, 204, 21, 0.25)',
      },
      secondary: {
        main: '#e6cc1f',
        light: '#f4df26',
        dark: '#d4bf1e',
        gradient: 'linear-gradient(135deg, #e6cc1f 0%, #f4df26 100%)',
        glow: 'rgba(230, 204, 31, 0.25)',
      },
      success: {
        main: '#059669',
        light: '#10b981',
        dark: '#047857',
        gradient: 'linear-gradient(135deg, #059669 0%, #34d399 100%)',
        glow: 'rgba(5, 150, 105, 0.25)',
      },
      warning: {
        main: '#d97706',
        light: '#f59e0b',
        dark: '#b45309',
        gradient: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)',
        glow: 'rgba(217, 119, 6, 0.25)',
      },
      danger: {
        main: '#dc2626',
        light: '#ef4444',
        dark: '#b91c1c',
        gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
        glow: 'rgba(220, 38, 38, 0.25)',
      },
      emergency: {
        main: '#b91c1c',
        light: '#dc2626',
        dark: '#991b1b',
        gradient: 'linear-gradient(135deg, #b91c1c 0%, #ef4444 100%)',
        glow: 'rgba(185, 28, 28, 0.35)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        muted: 'rgba(0, 0, 0, 0.45)',
      },
      preview: ['#facc15', '#fde047', '#e6cc1f', '#eab308'],
    },
  },
};

// Default theme (Cyan Teal)
export const defaultTheme = colorThemes.cyanTeal;

// Get theme by ID and mode (light/dark)
export const getThemeById = (themeId, mode = 'dark') => {
  const theme = colorThemes[themeId] || defaultTheme;
  if (!theme) {
    // Ultimate fallback
    return colorThemes.royalPurple?.dark || colorThemes.royalPurple?.light || {};
  }
  // If theme has light/dark structure, return the appropriate mode
  if (theme[mode]) {
    return {
      id: theme.id,
      name: theme.name,
      ...theme[mode],
    };
  }
  // Fallback for old structure (backward compatibility)
  return theme;
};

// Get all theme IDs
export const getAllThemeIds = () => {
  return Object.keys(colorThemes);
};



